"use client";

import styled from "styled-components";

import Image from "../image";

interface BoxAlertProductProps {
  $isLowStock?: boolean;
}

export const CardService = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--background);
  transition: all 0.3s ease;
  position: relative;
  height: 100%;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);

  &:hover {
    box-shadow:
      0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
    border-color: var(--primarySystem100);
  }
`;

export const BoxBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  gap: 12px;
  padding-top: 5px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 12px;
`;

export const ImageEmployee = styled(Image)`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  object-fit: cover;
  border: 2px solid var(--border);
  flex-shrink: 0;
`;

export const InfoHeader = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: calc(100% - 70px);
`;

export const BoxCategoryStart = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TypeCategory = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 6px;
  font-family: "Inter Medium";
  font-size: 11px;
  background: var(--grayCard);
  color: var(--textLight);
  border: 1px solid var(--border);
  white-space: nowrap;
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: nowrap;
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
`;

export const BoxIcon = styled.div`
  background: var(--softMint);
  border-radius: 5px;
  padding: 5px;
  svg {
    width: 18px;
    height: 18px;
    path {
      stroke: var(--greenAndWhite);
    }
    circle {
      stroke: var(--greenAndWhite);
    }
  }
`;

export const BoxAlign = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
  margin-bottom: 16px;
`;

export const Control = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--grayCard);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid var(--border);
  transition: all 0.2s ease;

  &:hover {
    background: var(--background);
    border-color: var(--primarySystem100);
  }
`;

export const TitleControl = styled.h4`
  font-family: "Inter Regular";
  font-size: 12px;
  color: var(--textLight);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const Value = styled.span`
  font-family: "Inter SemiBold";
  font-size: 18px;
  color: var(--titleColor);
  line-height: 1.2;
`;

export const TitleCard = styled.h3`
  font-family: "Inter SemiBold";
  font-size: 18px;
  color: var(--colorTitle);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin-bottom: 6px;
  line-height: 1.4;
`;

export const TitleDescription = styled.h4`
  font-family: "Inter Medium";
  font-size: 15px;
  color: var(--textLight);
`;

export const BodyCard = styled.div`
  width: 100%;
  text-align: left;
  margin-bottom: 12px;
`;

export const FooterCard = styled.div`
  border-top: 1px solid var(--border);
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  padding-top: 16px;
  margin-top: auto;

  button {
    width: 100%;
    font-size: 14px;
    padding: 10px 16px;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 8px;

    button {
      flex: 1;
      min-width: 0;
    }
  }
`;

export const TextDescription = styled.p`
  font-family: "Inter Regular";
  color: var(--textLight);
  font-size: 15px;
`;

export const BoxAlertProduct = styled.div<BoxAlertProductProps>`
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 50px;
  background-color: ${({ $isLowStock }) =>
    $isLowStock ? "#ffe5e5" : `var(--softMint)`};
  color: ${({ $isLowStock }) =>
    $isLowStock ? "#ff4d4f" : `var(--greenAndWhite)`};
  position: absolute;
  right: -5px;
  top: -10px;
`;

export const ScoreStar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Inter Regular";
  font-size: 15px;
  color: var(--textLight);
  gap: 3px;
  wdith: 100%;

  svg {
    width: 15px;
    height: 15px;
    stroke: var(--infoSystem);
    fill: var(--infoSystem);
    margin-top: -2px;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const ListItemEMployees = styled.ul`
  padding: 0;
  margin: 0;
`;

export const ItemEmployee = styled.li`
  display: flex;
  align-items: center;
  font-family: "Inter Regular";
  font-size: 13px;
  color: var(--textLight);
  gap: 8px;
  margin-bottom: 10px;
  padding: 6px 0;
  transition: color 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    width: 16px;
    height: 16px;
    color: var(--textLight);
    flex-shrink: 0;
    opacity: 0.7;
  }

  &:hover {
    color: var(--colorTitle);

    svg {
      opacity: 1;
      color: var(--primarySystem100);
    }
  }
`;
